import React from 'react';
import styled from 'styled-components';
import { StructuredPropertyEntity } from '../../../../../types.generated';

const Description = styled.div`
    padding-left: 16px;
`;

interface Props {
    structuredProperty: StructuredPropertyEntity;
}

export default function StructuredPropertyTooltip({ structuredProperty }: Props) {
    return (
        <div className="f-text-content">
            <div>Structured Property</div>
            <div>{structuredProperty.definition.displayName || structuredProperty.definition.qualifiedName}</div>
            {structuredProperty.definition.description && (
                <Description>{structuredProperty.definition.description}</Description>
            )}
        </div>
    );
}
